import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type TotalCasesColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const totalCasesColumnConfig = <T extends TableRow>({
  options,
}: TotalCasesColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'totalCases',
  label: <Trans i18nKey="total_cases" />,
  render: (value: number) => (
    <div className="overflow-hidden text-ellipsis">{value.toFixed(0)}</div>
  ),
  acessorKey: 'totalCases',
  sortable: false,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
